<template>
    <div id="dashboard-page" class="mb-5">
        <b-row class="mb-5">
          <!--<b-col cols="12" >
            <b-card class="outline-card">
              <b-row>
                <b-col md="6">
                  <a @click="getAllPersonal"><p>Total Personal <span class="ml-4 total-personal">{{totalPersonal}}</span></p></a>
                </b-col>
                <b-col md="6">
                  <b-card-group class="text-center">
                    <b-card no-body class="sub-card p-2">
                      <a @click="getActive"><p style="font-size:12px;">Active</p>
                      <span class="text-personal-count">{{active}}</span></a>
                    </b-card>
                    <div class="blok"></div>
                    <b-card no-body class="sub-card p-2">
                      <a @click="getOnLeave"><p style="font-size:12px;">On Leave</p>
                      <span class="text-personal-count">{{onLeave}}</span></a>
                    </b-card>
                  </b-card-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>-->
          <b-col md="12" class="">
            <b-card>
                <b-row>
                    <b-col>
                        <h3>{{$route.name}}</h3>
                        <b-breadcrumb>
                        <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
                        <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                        </b-breadcrumb>
                    </b-col>
                    <!-- <b-col md="6 mt-3 float-right">
                        <b-button variant="primary" class="mb-2 float-right btn-custom" :to="'employee/create'"><font-awesome-icon icon="plus"/></b-button>
                    </b-col> -->
                </b-row>
                <div class="border-bottom mb-3"></div>
                <b-form v-on:submit.prevent="doFilter">
                    <b-row>
                        <b-col md="12">
                            <b-row class="mt-1 mb-2">
                                <b-col md="3 mb-2">
                                    <b-form-input v-model="tableFilter.search" placeholder="Staff ID" />
                                </b-col>
                                <b-col md="3 mb-2">
                                    <b-form-input v-model="tableFilter.search_employee" placeholder="Name" />
                                </b-col>
                                <b-col md="3 mb-2">
                                    <b-form-select v-model="fakeTableFilter.active" :options="activeList" />
                                </b-col>
                                <b-col md="3 mb-2">
                                    <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Filter</button>
                                    <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Filter</button>
                                </b-col>
                            </b-row>
                            <div v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                                <b-row class="mb-2">
                                    <b-col md="3 mb-2">
                                        <b-form-select v-model="tableFilter.parent" :options="parentList" />
                                    </b-col>
                                    <b-col md="3 mb-2">
                                        <b-form-select v-model="tableFilter.company" :options="companyList" />
                                    </b-col>
                                    <b-col md="3 mb-2">
                                        <b-form-select v-model="tableFilter.branch" :options="branchList" />
                                    </b-col>
                                    <b-button variant="light" style="margin-left:-70px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                                    </b-button>
                                </b-row>
                            </div>
                            <div v-else></div>
                        </b-col>
                        <!--<b-col md="1 mt-1">
                            <b-button variant="primary" class="btn-back float-right btn-custom" :to="'personal/create'"><font-awesome-icon icon="plus"/></b-button>
                        </b-col>-->
                    </b-row>
                </b-form>
                <paginated-table ref="dataTable" :can-edit="true" :can-delete="false" :can-approve="false" :can-reject="false" :data-url="apiUrl.profile" :data-key="dataKey" :data-columns="columns" :data-params="['search', 'search_employee', 'parent_uuid', 'company_uuid', 'branch_uuid', 'active']">
                </paginated-table>
            </b-card>
          </b-col>
        </b-row>
    </div>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    // import Typeahead4 from '@/components/Typeahead4'
    export default {
        name: 'employee',
        components: {
            PaginatedTable,
            // Typeahead4
        },
        data () {
            return {
                dataKey: 'profile',
                apiUrl: {
                    profile: window.AppConfig.apiUrl + 'profile',
                    userAccess: window.AppConfig.apiUrl + 'user-access',
                },
                type: null,
                isLoadingBranch: false,
                columns: [
                    {
                        key: 'username',
                        label: 'Staff ID',
                        sortable: true
                    },
                    {
                        key: 'firstName',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'company',
                        label: 'Company',
                        sortable: true
                    },
                    {
                        key: 'branch',
                        label: 'Branch',
                        sortable: true
                    },
                    {
                        key: 'department',
                        label: 'Department',
                        sortable: true
                    },
                    {
                        key: 'statusPersonal',
                        label: 'Status',
                        sortable: false
                    },
                    {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
                tableFilter: {
                    company_uuid: this.$route.query.company_uuid,
                    company: null,
                    parent_uuid: this.$route.query.parent_uuid,
                    parent: null,
                    branch_uuid: this.$route.query.branch_uuid,
                    branch: null,
                    status: this.$route.query.status,
                    status: null,
                    search_employee: this.$route.query.search_employee,
                    active: this.$route.query.active
                },
                companyList: [
                    {
                        value: null,
                        text: 'Company'
                    }
                ],
                parentList: [
                    {
                        value: null,
                        text: 'PIC Name'
                    }
                ],
                branchList: [
                    {
                        value: null,
                        text: 'Branch'
                    }
                ],
                activeList: [
                    {
                        value: null,
                        text: 'Employee Status'
                    },
                    {
                        value: 0,
                        text: 'Not Active'
                    },
                    {
                        value: 1,
                        text: 'Active'
                    },
                ],
                fakeTableFilter: {
                    active: null
                },
                // active: null,
                // status: {
                //   active: "0",
                //   onLeave: "1",
                // },
                // onLeave: null,
                // totalPersonal: null,
            }
        },
        watch: {
            'tableFilter.company' (value) {
                this.getBranch(value)
            },
            // 'fakeTableFilter.active' (value) {
            //     this.doFilter(value)
            // }
        },
        mounted() {
            this.getCompany()
            this.getPICName()
        },
        methods: {
            doFilter () {
                this.tableFilter.active = this.fakeTableFilter.active
                this.tableFilter.company_uuid = this.tableFilter.company
                this.tableFilter.branch_uuid = this.tableFilter.branch
                this.tableFilter.parent_uuid = this.tableFilter.parent
                this.$refs.dataTable.doFilter(this.tableFilter)
                // if (isActive == null) {
                //     this.tableFilter.active = null   
                // } else {
                //     this.tableFilter.active = isActive ? 1 : 0   
                // }
            },
            // doFilter (isActive = null) {
            //     this.tableFilter.parent_uuid = this.tableFilter.parent
            //     this.tableFilter.company_uuid = this.tableFilter.company
            //     this.tableFilter.branch_uuid = this.tableFilter.branch
            //     if (isActive == null) {
            //         this.tableFilter.active = null   
            //     } else {
            //         this.tableFilter.active = isActive ? 1 : 0   
            //     }
            //     this.$refs.dataTable.doFilter(this.tableFilter)
            // },
            clearFilter () {
                this.tableFilter.search = null
                this.tableFilter.search_employee = null
                this.tableFilter.company = null
                this.tableFilter.branch = null
                this.tableFilter.parent = null
                this.tableFilter.active = null
                this.fakeTableFilter.active = null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getPICName () {
              this.$http.get(window.AppConfig.apiUrl + 'user-access').then(response => {
                response.data._embedded.user_access.forEach(data => {
                  let employeeFirstName = data.userProfile.firstName !== null ? data.userProfile.firstName : ''
                  let employeeLastName = data.userProfile.lastName !== null ? data.userProfile.lastName : ''
                  let names = employeeFirstName + '\xa0' + employeeLastName
                  this.fullName = names
                  this.parentList.push({
                    value: data.userProfile.uuid,
                    text: this.fullName
                  })
                })
              })
            },
            getCompany () {
              this.$http.get(window.AppConfig.apiUrl + 'company?limit=100').then(response => {
                response.data._embedded.company.forEach(data => {
                    this.companyList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              })
            },
            getBranch (companyUuid = null) {
              this.isLoadingBranch = true
              if (companyUuid != null && this.tableFilter.company != null) {
                //   this.doFilter()
                  this.tableFilter.branch_uuid = this.tableFilter.branch
                  this.tableFilter.branch = null
                  this.tableFilter.company_uuid = this.tableFilter.company
              } else {
                //   this.doFilter()
                  this.tableFilter.branch = null
                  this.tableFilter.company = null
              }
              this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(response => {
                this.branchList = []
                this.isLoadingBranch = false
                response.data._embedded.branch.forEach(data => {
                    this.branchList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              }).catch(error => {
                  window.consoleLog(error)
                  this.isLoadingBranch = false
              })
            }
        }
    }
</script>